import Icon from 'components/atoms/Icon';
import styles from './NoItemsDisplay.module.scss';

type NoItemsDisplayProps = {
  label?: string;
};

const NoItemsDisplay = ({ label }: NoItemsDisplayProps) => {
  return (
    <div className={styles.container}>
      <Icon icon="empty" />
      <p className={styles.text}>{`No ${label || 'items'} yet`}</p>
    </div>
  );
};

export default NoItemsDisplay;
